export default __webpack_public_path__ + "static/media/IMG_0484-2.cb24aa42.jpg";